import { useCallback, useState } from "react";
import { useMutation } from "@apollo/client";
import {
  saveUploadedImageMutation,
  getSignedUrlForImageUploadMutation,
} from "../mutations/images.graphql";

const useUploadImages = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [saveUploadedImage] = useMutation(saveUploadedImageMutation);
  const [getSignedUrlForImageUpload, { loading: isGettingSignedUrl }] =
    useMutation(getSignedUrlForImageUploadMutation);

  const uploadImages = useCallback(
    async (filesWithDimensions) => {
      setIsUploading(true);

      const uploadedImages = await Promise.all(
        filesWithDimensions.map(async (fileWithDimensions) => {
          const { file, height, width } = fileWithDimensions;

          const { data } = await getSignedUrlForImageUpload({
            variables: {
              input: {
                filename: file.name,
              },
            },
          });

          const { url: uploadURL, key: fileKey } =
            data.getSignedUrlForImageUpload;

          await fetch(uploadURL, {
            method: "PUT",
            headers: {
              "Content-Type": file.type,
            },
            body: file,
          });

          const { data: saveUploadedImageData } = await saveUploadedImage({
            variables: {
              input: {
                name: file.name,
                mimeType: file.type,
                description: "",
                fileKey,
                fileSize: file.size,
                width,
                height,
              },
            },
          });

          return saveUploadedImageData?.saveUploadedImage?.image;
        })
      );

      setIsUploading(false);

      return uploadedImages;
    },
    [getSignedUrlForImageUpload, saveUploadedImage]
  );

  return { uploadImages, isUploading: isUploading || isGettingSignedUrl };
};

export default useUploadImages;
